import { Component, OnInit, Input, Inject, PLATFORM_ID, ElementRef, ViewChild, AfterViewInit} from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { ApiService } from '../../services/api.service';
// import { Chart, LineController, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, registerables, TimeScale, TimeSeriesScale } from 'chart.js';
// import Zoom from 'chartjs-plugin-zoom';
// import 'chartjs-adapter-date-fns';
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
import { isPlatformServer } from '@angular/common';
// import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-stock-chart',
  templateUrl: './stock-chart.component.html'
})
export class StockChartComponent implements OnInit, AfterViewInit {
  @Input() rendering: ComponentRendering;
  @ViewChild('StockChart', { static: false }) stockChart!: ElementRef;
  data: any;
  request:any;
  stockRecords:any;
  datePickerFrom:Date;
  datePickerTo:Date;
  StockSymbol:any;
  emptyFilter:boolean=false;
  DateFromLaterThanDateTo:boolean=false;
  DateMustBePreviousThanToday:boolean=false;
  myChart:any;
  activeFilter: string = '1M';
  public contextSubscription: Subscription;
  language:string;
  _isPlatformServer:boolean;

  constructor(protected apiService: ApiService, @Inject(PLATFORM_ID) public readonly platformId: string, public jssContext: JssContextService) {
    // if (isPlatformBrowser(this.platformId)) {
    //   Chart.register(LineController,CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Zoom, ...registerables, TimeScale, TimeSeriesScale);
    // }
  }
  
  ngOnInit() {
    
    this._isPlatformServer = isPlatformServer(this.platformId);
    if ( this.rendering.fields.result ){
      //debugger;
      this.data =  this.rendering.fields?.result;
      this.StockSymbol= this.rendering?.fields?.['Stock-Symbol'];
      this.StockSymbol=this.StockSymbol.value;
    }

    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
  }
  
  ngAfterViewInit(): void {
    if(!this._isPlatformServer){

      var _this = this;
      if((this.rendering?.fields as any)?.result?.StockChartPriceRecords?.StockChartRecords?.length > 0 && this.stockChart?.nativeElement){
        var initLabels = (this.rendering?.fields as any)?.result?.StockChartPriceRecords?.StockChartRecords.map((item : any) => new Date(item?.ClosingDate))?.reverse();
        var initData = (this.rendering?.fields as any)?.result?.StockChartPriceRecords?.StockChartRecords.map((item : any) => item?.StockData)?.reverse();
  
        import("chart.js").then((ChartModule) => {

          
          const {Chart,LineController,CategoryScale,LinearScale,PointElement,LineElement,Tooltip,Legend,registerables,TimeScale,TimeSeriesScale} = ChartModule;
  
          import("chartjs-plugin-zoom").then((ZoomModule) => {
            // @ts-ignore
            import("chartjs-adapter-date-fns").then(() => {
              // The date-fns adapter is now loaded and ready to use with Chart.js
              Chart.register(...registerables, LineController,CategoryScale,LinearScale,PointElement,LineElement,Tooltip,Legend, TimeScale,TimeSeriesScale,ZoomModule.default);
    
              this.myChart = new ChartModule.Chart(this.stockChart.nativeElement, {
                type: "line",
                data: {
                  labels: initLabels,
                  datasets: [
                    {
                      label:"",
                      data: initData,
                      fill:false,
                      tension:0.1,
                      borderDashOffset:0.8,
                      borderColor:"#1E1E1E",
                      pointBackgroundColor:"#FFD900",
                      pointRadius:6,
                      pointHoverBackgroundColor:"#FFD900",
                      hoverBackgroundColor:"#CAC3AF",
                      pointHoverBorderWidth:6,
                      pointHoverRadius:8,
                      pointHoverBorderColor:"#002F30"
                    },
                  ],
                },
                options: {
                  responsive:true,
                  scales:{
                    x:{
                      type: 'time',
                      min: initLabels[0],
                      max: initLabels[initLabels.length - 1],
                      time: {
                        tooltipFormat: this.language == "el" ? 'dd/MM/yy' : 'MM/dd/yy',
                        unit: 'day',  // Show by year initially
                        displayFormats: {
                          day: this.language == "el" ? 'dd/MM/yy' : 'MM/dd/yy',      // Custom format for days
                        },
                      },
                      grid:{
                        lineWidth:0.5,
                        color:"#E5E1D7",
                      },
                      border:{
                        width:2,
                        color:"#DAD5C7"
                      },
                      ticks:{
                        color:"#1E1E1E",
                        autoSkip:true,
                        font:{
                          size:12
                        },
                        source: 'auto',   // Automatically adjust based on data
                        maxTicksLimit:10,
                      }
                    },
                    y:{
                      grid:{
                        lineWidth:0.5,
                        color:"#E5E1D7",
                      },
                      border:{
                        width:2,
                        color:"#DAD5C7"
                      },
                      ticks:{
                        color:"#1E1E1E",
                        font:{
                          size:12
                        }
                      }
                    }
                  },
                  plugins: {
                    legend: {
                      display: false
                    },
                    tooltip:{
                      backgroundColor: '#CAC3AF',
                      displayColors:false,
                      padding:16,
                      bodyColor:"#1E1E1E",
                      titleColor:"#1E1E1E",
                      titleAlign:"center",
                      titleFont: {
                        size: 14,   // Font size for title
                        family:"Piraeus Open Sans"
                      },
                      bodyFont: {
                        size: 36,  // Font size for body text
                        family:"Piraeus Open Serif"
                      },
                      callbacks: {
                        label: function(context) {
                          return "€ "+(+context?.formattedValue).toLocaleString(_this.language);
                        },
                        // title: function(context) {
                        
                        //   return "lakis";
                        // },
                      }
                    },
                    zoom:{
                      limits:{
                        x: {min: new Date(initLabels[0]).setDate(initLabels[0].getDate()-1) , max: new Date(initLabels[initLabels.length - 1]).setDate(initLabels[initLabels.length - 1].getDate()+1), minRange: 0},
                        y: {min: 0, max: Math.max(...initData)+5, minRange: 0}
                      },
                      pan:{
                        enabled:true,
                        mode:'xy',
                      },
                      zoom:{
                        wheel:{
                          // enabled:true
                          enabled:false
                        },
                        mode:'xy',
                        onZoomComplete({chart}) {
                          chart.update('none');
                        }
                      }
                    }
                  },
                },
              });
            });  
          });
  
  
        });
      }
    }
  }

  OnDateFromClick(){
    this.clearErrors();
  }
  OnDateToClick(){
    this.clearErrors();
  }
  
  OnDateFromChange(event: any) {
    
    this.datePickerFrom = event;
    let dateTime = new Date();
    if (this.datePickerFrom > dateTime){
      this.DateMustBePreviousThanToday=true;
    }
  }

  OnDateToChange(event: any) {
    this.datePickerTo = event;
    let dateTime = new Date();
    if (this.datePickerTo > dateTime){
      this.DateMustBePreviousThanToday=true;
    }
  }

  clearErrors()
  {
    this.emptyFilter=false;
    this.DateFromLaterThanDateTo=false;
    this.DateMustBePreviousThanToday=false;
  }
  getStockRecords()  {
    this.emptyFilter=false;
    if (this.datePickerFrom == null || this.datePickerFrom ==undefined || this.datePickerTo == null || this.datePickerTo ==undefined){
      this.emptyFilter=true;
      return;
    }

    this.DateFromLaterThanDateTo=false;
    if (this.datePickerFrom > this.datePickerTo){
      this.DateFromLaterThanDateTo=true;
    }

    var request = {
      StockSymbol: this.StockSymbol,
      ChartType: 1,
      DateFrom:this.datePickerFrom,
      DateTo:this.datePickerTo
    }

    //debugger;
    this.apiService.fetch<any>("/piraeusapi/integration/StockChart/getstockchartdata", request ).
      then(resp => {
        if (resp.status === 200 ) {
          if( resp.data){
            this.stockRecords=resp.data;
          }
        }
    });
  }

  updateChart(label:string){
    this.myChart.resetZoom();
    var request:any;
    this.activeFilter = label;
    if(label=="5D"){
      request = {
        StockSymbol: this.StockSymbol,
        ChartType: 1,
        DateFrom:new Date(new Date(new Date().setDate(new Date().getDate()-7)).setHours(0, 0, 0, 0)),
        DateTo: new Date()
      }
    }else if(label=="1M"){
      request = {
        StockSymbol: this.StockSymbol,
        ChartType: 1,
        MonthsCount:1,
        DateFrom:"",
        DateTo: ""
      }
    }else if(label=="2M"){
      request = {
        StockSymbol: this.StockSymbol,
        ChartType: 1,
        MonthsCount:2,
        DateFrom:"",
        DateTo: ""
      }
    }else if(label=="6M"){
      request = {
        StockSymbol: this.StockSymbol,
        ChartType: 1,
        MonthsCount:6,
        DateFrom:"",
        DateTo: ""
      }
    }else if(label=="1Y"){
      request = {
        StockSymbol: this.StockSymbol,
        ChartType: 1,
        MonthsCount:12,
        DateFrom:"",
        DateTo: ""
      }
    }
    // else if(label=="5Y"){
    //   request = {
    //     StockSymbol: this.StockSymbol,
    //     ChartType: 1,
    //     MonthsCount:60,
    //     DateFrom:"",
    //     DateTo: ""
    //   }
    // }
    else{
      return;
    }

    // debugger;
    this.apiService.fetch<any>("/piraeusapi/integration/StockChart/getstockchartdata", request ).
      then(resp => {
        if (resp.status === 200 ) {
          if( resp.data){
            this.stockRecords=resp.data;
            if(label=="5D" && this.stockRecords?.StockChartRecords?.length>5){
              this.stockRecords?.StockChartRecords?.pop();
            }
            var initLabels = this.stockRecords.StockChartRecords.map((item : any) => new Date(item?.ClosingDate))?.reverse();
            var initData = this.stockRecords.StockChartRecords.map((item : any) => item?.StockData)?.reverse();
            this.myChart.data.labels = initLabels;
            this.myChart.data.datasets[0].data = initData;
            this.myChart.options.plugins.zoom.limits.x.min =  new Date(initLabels[0]).setDate(initLabels[0].getDate()-1);
            this.myChart.options.plugins.zoom.limits.x.max = new Date(initLabels[initLabels.length - 1]).setDate(initLabels[initLabels.length - 1].getDate()+1);
            this.myChart.options.plugins.zoom.limits.y.min = 0;
            this.myChart.options.plugins.zoom.limits.y.max = Math.max(...initData)+5;
            this.myChart.options.scales.x.min = initLabels[0];
            this.myChart.options.scales.x.max = initLabels[initLabels.length-1];
// min: new Date(initLabels[0]).setDate(initLabels[0].getDate()-1) , max: new Date(initLabels[initLabels.length - 1]).setDate(initLabels[initLabels.length - 1].getDate()+1)
            // this.myChart.plugins.zoom.update();
            // this.myChart.options.scales.x.ticks.callback = function(index:any) {
            //   //   // Only show labels for every 10th point
            //   return index % 10 === 0 ? this.getLabelForValue(index) : '';
            // }
            // this.myChart.
          }
        }
      }).finally(() => {
        this.myChart.update();
        setTimeout( () => {
          this.myChart.resetZoom();
        },500)
      });
  }

  getTimeUnit(zoomLevel: number): string {
    if (zoomLevel < 10) {
      return 'day';   // Show days when fully zoomed in
    } else if (zoomLevel < 30) {
      return 'month'; // Show months when moderately zoomed in
    } else {
      return 'year';  // Show years when zoomed out
    }
  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
        this.contextSubscription.unsubscribe();
    }
  }

  percentageChange(firstNumber: number, secondNumber:number){
    var percent = ((firstNumber-secondNumber)/secondNumber)*100;
    return percent; 
  }
  percentageChangeNumber(firstNumber: number, secondNumber:number){
    return ((firstNumber-secondNumber)/secondNumber)*100;
  }

  roundUp(num: number){
    return Number(num.toFixed(2)).toLocaleString(this.language);
  }

} 

